/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of the workspace
*/
export enum WorkspaceStatus {
  WORKSPACE_STATUS_PENDING = 'PENDING',
  WORKSPACE_STATUS_ACTIVE = 'ACTIVE',
  WORKSPACE_STATUS_FAILED = 'FAILED'
}
